<template>
    <div class="flex flex-col sm:flex-row border-b border-gray-400 py-4">
        <input-checkbox
            name="our_sale"
            label="Our Listing"
            v-model="our_sale"
            class="sm:w-1/3"
            :read_only="read_only"
        />

        <input-checkbox
            name="our_purchase"
            label="Our Purchase"
            v-model="our_purchase"
            class="sm:w-1/3"
            :read_only="read_only"
        />

        <input-checkbox
            name="under_contract"
            label="Under Contract"
            :value="deal.under_contract"
            class="sm:w-1/3"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        our_sale: {
            get() {
                return store.state.our_sale || 0;
            },
            set(val) {
                store.state.our_sale = (val ? 1 : 0);
            },
        },
        our_purchase: {
            get() {
                return store.state.our_purchase || 0;
            },
            set(val) {
                store.state.our_purchase = (val ? 1 : 0);
            },
        },
    },
}
</script>
